module.exports = __webpack_public_path__ + "img/jz_health.54ec774f.png";